import { render, staticRenderFns } from "./Around.vue?vue&type=template&id=180d67de&scoped=true&"
import script from "./Around.vue?vue&type=script&lang=js&"
export * from "./Around.vue?vue&type=script&lang=js&"
import style0 from "./Around.vue?vue&type=style&index=0&id=180d67de&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "180d67de",
  null
  
)

export default component.exports